// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { headerLinkListStyles } from "@vanmeter/Overrides/Widgets/Header/HeaderLinkList";
import { fontConfig } from "@vanmeter/XDL/constants";
import { color } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        gap: 24px;
        justify-content: flex-end;
    `,
};

headerLinkListStyles.link = {
    typographyProps: {
        ...fontConfig.smallSingleLine,
    },
    css: css`
        &:not(:last-child) {
            padding-right: 24px;
            border-right: 1px solid ${color("common.border")};
        }
        ${IconWrapper} {
            margin-right: 8px;
        }
        &:hover {
            ${IconWrapper},svg {
                color: ${color("common.ui19")};
            }
        }
    `,
};
